import { CustomerQueryKeys } from "../Customer/keys";

export const CustomerSettingQueryKeys = {
  all: (customerId: string) => [
    ...CustomerQueryKeys.single(customerId),
    "settings",
  ],
};
